import {forEach} from 'ramda';
import schedule from '../../scripts/util/window/schedule';
import randomInteger from '../../scripts/util/generate/randomInteger';
import isElement from '../../scripts/util/isElement';
import getCoords from '../../scripts/util/window/getCoords';
import scrolling from '../../scripts/util/window/smoothScrolling';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import $ from 'jquery';

const selectors = {
	el: '.js-adaptive-trigger',
	container: '.js-adaptive-container',
	row: '.js-devices-row',
	device: '.js-device',
	different: {
		ipad: '.js-diff-ipad',
		iphone: '.js-diff-iphone',
		draw: '.js-diff-draw'
	},
	image: '.js-device-image',
	adaptive: '.js-adaptive-slideshow'
};

const classes = {
	image: {
		current: 'adaptive__image_state_current'
	},
	row: {
		transition: {
			disable: 'adaptive__devices_transition_disable',
			enable: 'adaptive__devices_transition_enable'
		}
	}
};

const devices = () => document.querySelectorAll(selectors.device);

const element = document.querySelector(selectors.el);
const wrapper = document.querySelector(selectors.container);
const pad = document.querySelector(selectors.different.ipad);
const phone = document.querySelector(selectors.different.iphone);
const draw = document.querySelector(selectors.different.draw);

const getMouseCoord = (e, el) => {
	const coord = getCoords(el);
	const mousePos = {
		top: e.pageY - coord.top,
		left: e.pageX - coord.left
	};
	return mousePos;
};


const onMove = (e, width, height) => {
	const mousePos = getMouseCoord(e, element);
	const diffX = (-1 * ((width / 2) - mousePos.left));
	const diffY = ((height / 2) - mousePos.top);
	const translateX = diffX / 25;
	const translateY = diffY / 15;

	wrapper.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`;
	pad.style.transform = `translateX(${translateX / 2}px) translateY(${-translateY / 2}px) translateZ(0)`;
	phone.style.transform = `translateX(${translateX / 5}px) translateY(${-translateY / 5}px) translateZ(0)`;
	draw.style.transform = `translateX(${-translateX}px) translateY(${-translateY}px) translateZ(0)`;
};

const onEnter = row => () => {
	row.classList.add(classes.row.transition.enable);
	setTimeout(() => row.classList.remove(classes.row.transition.enable), 220);
};

const mouseAnimate = () => {
	if (element) {
		const row = element.querySelector(selectors.row);
		const width = element.offsetWidth;
		const height = element.offsetHeight;
		element.addEventListener('mousemove', e => onMove(e, width, height));
		element.addEventListener('mouseenter', onEnter(row));
	}
};

const checkSafari = () => {
	const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
	return isSafari;
};

const safariDisableTrans = () => {
	if (element) {
		const row = element.querySelector(selectors.row);
		if (checkSafari()) {
			row.classList.add(classes.row.transition.disable);
		}
	}
};

const randomChangeImg = item => {
	const images = item.querySelectorAll(selectors.image);
	const length = images.length;

	const changeImage = () => {
		const id = randomInteger(1, length);
		const activeImg = item.querySelector(`.${classes.image.current}`);
		const nextImg = item.querySelector(`[data-id='${id}']`);
		activeImg.classList.remove(classes.image.current);
		nextImg.classList.add(classes.image.current);

		schedule(changeImage, 2, 10);
	};

	if (length > 1) {
		schedule(changeImage, 2, 10);
	}
};

const changeViewType = () => {
	if (window.innerWidth > 1023) {
		document.body.classList.remove('is--mobile');
		document.body.classList.add('is--desktop');
	} else {
		document.body.classList.remove('is--desktop');
		document.body.classList.add('is--mobile');
	}
};

const render = () => {
	scrolling();
	if (isElement(selectors.device) && !isViewport(lg)) {
		safariDisableTrans();
		const adaptiveOffset = $(selectors.adaptive).offset().top;
		let slideshowStarted = false;
		$(window).scroll(function () {
			if ($(window).scrollTop() > adaptiveOffset && slideshowStarted === false) {
				slideshowStarted = true;
				forEach(randomChangeImg)(devices());
			}
		});
	}

	changeViewType();
	window.onresize = changeViewType;
};

export default render;
export {mouseAnimate};
